import React, { useState, useEffect } from "react"
import { Dialog, Typography, Grid, Paper, TextField } from "@mui/material"
import ButtonWithIcon from "../Button/Button"
import { ReactComponent as CloseSquareIcon } from "src/v2/assets/icons/close-square-icon.svg"
import { ReactComponent as CheckIcon } from "src/v2/assets/icons/check-icon.svg"
import PropTypes from "prop-types"

/**
 * Modal genérico de edição de texto longo, usado hoje pelo OCR
 * (ocr-prompt-component.js) e pela rotina B3 Fundos NET V2
 * (routine-prompt-field.js). Não sabe nada sobre "prompt" especificamente
 * -- qualquer tela que precise coletar/editar um texto livre longo antes
 * de confirmar uma ação pode reaproveitar este componente, só trocando
 * "title"/"placeholder".
 */
const TextBox = ({ open, onClose, onConfirm, initialText, title, placeholder }) => {
    const [texto, setTexto] = useState("")

    useEffect(() => {
        if (open) {
            setTexto(initialText || "")
        }
    }, [open, initialText])

    const handleSalvar = () => {
        onConfirm(texto)
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <Paper sx={{ p: 3, borderRadius: 0, backgroundColor: 'background.paper' }}>
                <Grid container direction="column" spacing={2}>

                    <Grid item>
                        <Typography variant="h6" sx={{ color: 'common.white' }}>
                            {title}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            multiline
                            minRows={15}
                            maxRows={20}
                            value={texto}
                            onChange={(e) => setTexto(e.target.value)}
                            fullWidth
                            variant="outlined"
                            placeholder={placeholder}
                            sx={{
                                mt: 1,
                                backgroundColor: 'background.tertiary',
                                borderRadius: 1,
                                '& .MuiInputBase-input': {
                                    color: 'white.main',
                                    fontFamily: 'monospace',
                                    fontSize: '0.9rem',
                                    lineHeight: 1.5
                                },
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#475569',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#94a3b8',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#94a3b8',
                                    }
                                }
                            }}
                        />
                    </Grid>

                    <Grid item container justifyContent="flex-end" spacing={2} sx={{ mt: 1 }}>
                        <Grid item>
                            <ButtonWithIcon
                                onClick={onClose}
                                startIcon={<CloseSquareIcon />}
                            >
                                CANCELAR
                            </ButtonWithIcon>
                        </Grid>
                        <Grid item>
                            <ButtonWithIcon
                                startIcon={<CheckIcon />}
                                onClick={handleSalvar}>
                                SALVAR
                            </ButtonWithIcon>
                        </Grid>
                    </Grid>

                </Grid>
            </Paper>
        </Dialog>
    )
}

TextBox.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    initialText: PropTypes.string,
    title: PropTypes.string,
    placeholder: PropTypes.string,
}

TextBox.defaultProps = {
    initialText: "",
    title: "Editar texto",
    placeholder: "",
}

export default TextBox